import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TitleManagerService } from './title-manager.service';

@NgModule({
  imports: [CommonModule],
  providers: [TitleManagerService],
})
export class TitleManagerModule {}
